/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Typography from "@mui/material/Typography";

export default function BasicDatePicker({
  label,
  useDefaultBorders,
  onChange,
  value,
  required,
  ...props
}) {
  const datePickerStyles = useDefaultBorders
    ? {}
    : {
        "& .MuiOutlinedInput-root": {
          border: "none",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          border: "none",
        },
        "& .MuiInputBase-root": {
          borderBottom: "1px solid #BCBCBC",
          borderRadius: "0px",
        },
      };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {/* <div style={{ display: "flex", flexDirection: "column" }}> */}
      <DatePicker
        label={
          <label style={{ display: "flex", alignItems: "center" }}>
            {label}{" "}
            {required && (
              <Typography variant="caption" color="error" sx={{ fontSize: 16 }}>
                *
              </Typography>
            )}
          </label>
        }
        sx={datePickerStyles}
        onChange={onChange}
        value={value}
        slotProps={{ textField: { size: "small" } }}
        format="DD/MM/YYYY"
        {...props}
      />
      {/* </div> */}
    </LocalizationProvider>
  );
}
